import BostadAd from './BostadAd'

export default BostadAd
